module.exports = __webpack_public_path__ + "fonts/Figtree-Medium-3cd26f0.ttf";